import React, { useEffect } from 'react';

export const BackdropFilterDetector: React.FC = () => {
  useEffect(() => {
    const isBackdropFilterSupported = () => {
      const el = document.createElement('div');
      el.style.cssText = 'backdrop-filter: blur(1px)';
      return el.style.backdropFilter === 'blur(1px)';
    };

    if (!isBackdropFilterSupported()) {
      document.body.classList.add('no-backdrop-filter');
    }
  }, []);

  return null;
};
